import { Component, OnInit } from '@angular/core';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import {HeaderButton} from 'src/app/models/headerbtn.model';
import {ComponentheaderService} from 'src/app/services/componentheader.service';
import { from } from 'rxjs';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-usermodules',
  templateUrl: './usermodules.component.html',
  styleUrls: ['./usermodules.component.css']
})
export class UsermodulesComponent implements OnInit {
  //breadcrumb :  BreadCrumb[] = [{displaytext: 'Home', route: '/user'}];  
  headerbtn : HeaderButton[];
  myModuleList:any[];
  moduleNotification:any;
  modulesURL: string;// = "asdf";
  currentUserIsAdmin: boolean = false;
  constructor(public headerinfo : ComponentheaderService, public modulemanager : ModulemanagementService, private router : Router, private util: UtilService) {
    this.headerinfo.setHeaderDisplay('My Courses', [ {displaytext: 'My Courses', route: '/user/usermodules'}], []);
    
   }

  async ngOnInit() {
    //debugger;
    
    this.modulesURL = this.modulemanager.getMyEnrolledModulesURL();
    this.currentUserIsAdmin = await this.util.checkUserIsSubdomainAdmin().toPromise();
    //setup the component header
    // this.modulemanager.getMyEnrolledModules(  
    // ).subscribe(
    //   (data:any)=>{
    //     this.myModuleList = data;
    //   },
    //   (err : HttpErrorResponse)=>{
    //     if(err.status == 0){
    //       this.moduleNotification = "Unable to fetch Courses";
    //     }else if(err.status == 400){
    //       this.moduleNotification = err.error.message;
    //     }
          
    //   }
    // )
  }
}
